import axios, { AxiosRequestConfig } from 'axios';
import env from 'constants/env.json'
import { UserProvider } from 'modules/User'
import { message } from 'antd';

const { httpBaseUrl } = env;

let deviceInfo = {
	appId: "1.0.0",
	devType: "14",
};

const httpInit = axios.create({
	// timeout: 10000,
});

export async function configHttp() {
	httpInit.interceptors.request.use(async (config) => {
		const { url } = config;
		let user = UserProvider.getCurrentUser()
		if (user.userId) {
			config.headers.common.userId = user.userId;
			config.headers.common.Authorization = user.token;
		}
		if (url && url.indexOf('http') !== 0) {
			config.url = httpBaseUrl + config.url
		}

		return config;
	})
	httpInit.interceptors.response.use((res) => {
		const body = res.data;
		if (body.code === 401) {
			UserProvider.loginOut()
			// store.dispatch({ type: "SIGN_OUT" })
			throw body;
		}
		else if (parseInt(body.code, 10) !== 200) {
			return Promise.reject(body)
		}
		return body

	}, (error) => {
		message.error('系统出错，请联系管理员')
		// if (error.message.indexOf('timeout') > -1) { 

		// }
		console.error('http error', error)
		return Promise.reject(error)
	});
	return httpInit
}


configHttp()

export default httpInit


// WEBPACK FOOTER //
// ./src/services/http.ts